module.exports = __webpack_public_path__ + "static/img/core-3.be819140.png";